export default __webpack_public_path__ + "static/media/generating-thumbnail.21c67462.jpg";